import { __assign, __rest } from "tslib";
import React from 'react';
import { Card } from '@marvelapp/ui';
import Loading from './Loading';
export default function CardUploading(_a) {
    var isDragged = _a.isDragged, isDraggingMultiple = _a.isDraggingMultiple, isSelected = _a.isSelected, props = __rest(_a, ["isDragged", "isDraggingMultiple", "isSelected"]);
    return (React.createElement(Card, { className: "not-selectable", isDragged: isDragged && !isDraggingMultiple, isSelected: isSelected },
        React.createElement(Loading, __assign({}, props))));
}
